import { TypographyProps } from '../typography'
import { heading } from './components'

type HeadingWeights = {
  1: 'bold'
  2: 'medium'
  3: 'medium' | 'regular'
  4: 'bold'
  5: 'bold' | 'medium' | 'regular'
}
export type HeadingLevel = 1 | 2 | 3 | 4 | 5

export interface HeadingProps<Level extends HeadingLevel>
  extends TypographyProps<Level> {
  level: Level
  weight?: HeadingWeights[Level]
}

const Heading = <Level extends HeadingLevel = HeadingLevel>(
  props: HeadingProps<Level>
) => {
  const { children, level, weight, ...restProps } = props
  const RenderedHeading = heading[level as HeadingLevel]

  return (
    <RenderedHeading $weight={weight} {...restProps}>
      {children}
    </RenderedHeading>
  )
}

export default Heading
